import React,{Component} from 'react';

// Simple PDF viewer for modal usage - no Redux dependency
export class SimplePDFViewer extends Component{
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            error: null,
            scale: 1.0
        };
        this.handleLoad = this.handleLoad.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    componentDidMount(){
        // PDF URL is already validated by parent component
        if(this.props.pdfUrl){
            this.setState({ loading: false });
        }
    }

    handleLoad(){
        this.setState({ loading: false, error: null });
    }

    handleError(error){
        console.error('PDF loading error:', error);
        this.setState({ 
            loading: false, 
            error: error 
        });
        if(this.props.onError){
            this.props.onError(error);
        }
    }

    render(){
        const { pdfUrl } = this.props;
        const { loading, error } = this.state;

        if(loading){
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                    <div>Loading PDF...</div>
                </div>
            );
        }

        if(error){
            return (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px', flexDirection: 'column' }}>
                    <div>Failed to load PDF</div>
                    <div style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>{error}</div>
                </div>
            );
        }

        return (
            <div style={{ width: '100%', height: '100%' }}>
                <iframe
                    src={pdfUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 'none', minHeight: '600px' }}
                    title="PDF Viewer"
                    onLoad={this.handleLoad}
                    onError={() => this.handleError('Failed to display PDF')}
                />
            </div>
        );
    }
}

export default SimplePDFViewer;
